import React from "react";

function StringFilter(props) {
    return (
        <>
            <input type="number" name={props.name} onChange={props.onChange} value={props.value} style={{ width: '100%' }}/>
        </>
    )
}
export default StringFilter
